import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Divider, Menu, MenuItem, ListItemIcon, Typography } from '@mui/material';
import { AccountCircle, Business, Logout, Notifications } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { User, UserRole } from '@avanzu/types';

interface ProfileMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  user: User | null;
  userRole?: UserRole;
}

export const ProfileMenu: React.FC<ProfileMenuProps> = ({
  anchorEl,
  open,
  onClose,
  user,
  userRole,
}) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleMenuItemClick = (path: string) => {
    onClose();
    navigate(path);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Box sx={{ px: 2, py: 1 }}>
        <Typography variant="body1">
          {user?.firstName} {user?.lastName}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {userRole || 'MEMBER'}
        </Typography>
      </Box>
      <Divider />
      {/* <MenuItem onClick={() => handleMenuItemClick('/select-organisation')}>
        <ListItemIcon>
          <Business fontSize="small" />
        </ListItemIcon>
        Change Organisation
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('/settings/profile')}>
        <ListItemIcon>
          <AccountCircle fontSize="small" />
        </ListItemIcon>
        Profile Settings
      </MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('/settings/notifications')}>
        <ListItemIcon>
          <Notifications fontSize="small" />
        </ListItemIcon>
        Notifications
      </MenuItem>
      <Divider /> */}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
};
